export default "__VITE_ASSET__4DqyX8_d__"